 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		71: 0,
 		69: 0,
 		70: 0,
 		79: 0,
 		123: 0,
 		124: 0,
 		131: 0,
 		132: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~df3bb2ca","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","6":"AddClosedAlertIDUseCase","7":"CreateDeviceUseCase","8":"CreateDomestikaFollowUseCase","9":"CreateJWTUserUseCase","10":"CreateUserLiveSessionUseCase","11":"CurrentUserUseCase","12":"CurrentWithoutRelationshipsUserUseCase","13":"DeleteDeviceUseCase","14":"DeleteFollowUseCase","15":"ENV_CONFIG1","16":"ENV_CONFIG4","17":"ENV_CONFIG5","18":"ENV_CONFIG6","19":"ENV_CONFIG7","20":"FinishUserLiveSessionUseCase","21":"GetAccessTokenUserUseCase","22":"GetAdvanceGDPRStatusUserUseCase","23":"GetAllBlogUseCase","24":"GetAreasCourseUseCase","25":"GetCartCourseUseCase","26":"GetCategoriesCourseUseCase","27":"GetCourseUseCase","28":"GetFinalProjectVideoByCourseIDCourseUseCase","29":"GetGDPRStatusUserUseCase","30":"GetListLiveFeedbackQuestionUseCase","31":"GetListLiveSessionUseCase","32":"GetListLiveStreamUseCase","33":"GetLiveChannelUseCase","34":"GetLiveSessionUseCase","35":"GetOrganizationUseCase","36":"GetPlusPromotionUseCase","37":"GetPostContentBlogUseCase","38":"GetPromotionCodeAlertUseCase","39":"GetPromotionUseCase","40":"GetPubnubCredentialsUseCase","41":"GetSessionDataUserUseCase","42":"GetSimpleUserUseCase","43":"GetSoftwaresCourseUseCase","44":"GetUserAlertUseCase","45":"GetVideoProgressListCourseUseCase","46":"GetVideoSpeedUserUseCase","47":"GetVideoVolumeUserUseCase","48":"LogoutUserUseCase","49":"PathToRegexp","50":"RefreshAccessTokenUserUseCase","51":"RemoveAccessTokenUserUseCase","52":"SearchCourseUseCase","53":"SendHeaderTrackingUseCase","54":"SendLiveFeedbackAnswersUseCase","55":"SendPlayerTrackingUseCase","56":"SendTrackingUseCase","57":"SendVideoProgressCourseUseCase","58":"SetAdvanceGDPRStatusUserUseCase","59":"SetGDPRStatusUserUseCase","60":"SetVideoSpeedUserUseCase","61":"SetVideoVolumeUserUseCase","62":"UpdateLanguageUserUseCase","63":"UpdateLiveSessionUseCase","64":"UpdateVideoAudioAndSubtitlesCourseUseCase","65":"UpdateVideoProgressCourseUseCase","66":"ViewPageTrackingUseCase","133":"vendors~AddClosedAlertIDUseCase","134":"vendors~AlgoliaSearch","135":"vendors~AmplitudeJS","136":"vendors~GetAdvanceGDPRStatusUserUseCase","137":"vendors~RemoveAccessTokenUserUseCase","138":"vendors~SearchCourseUseCase","139":"vendors~SetGDPRStatusUserUseCase","140":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"0776b629713a03816d20","1":"60436f9ce5653e2d51a6","2":"1f8cce1467a8916a397c","3":"2a462eb842d804f7d8a9","4":"4af60be8c3f64da43ca0","5":"ad85a26be62745b9a853","6":"f5e34d3e71f958f586f0","7":"a71df46ecca00db3acea","8":"74dd41ffc399cab8590f","9":"31c9b9c1e52d9d2a7657","10":"b36e8d450ada4dd604ea","11":"ff67930d315c0e5042e0","12":"3ab40c7d678d3b3712e4","13":"8c734dbfb727a5ff0505","14":"4f3451b8623f245dbb62","15":"8f8db43dce1685137987","16":"99dadbe0687e2d3c442c","17":"3d73ec6242e0b6e55af8","18":"b6f9aeef07e2a17cbdaf","19":"66b46b8cf8bba91beda6","20":"84af2696e3b7c08bb1bf","21":"a93215f46b6c060ed458","22":"8933cc40aae9a2900784","23":"e82c028930e8c290646c","24":"831bec0118093c56511e","25":"eb89ff1d79e7aecd80d1","26":"73d9a2a006a9b622db9b","27":"792b401627c1bc3720fb","28":"a842e0b3ad3d9cc725a9","29":"46a8569798834f5cce2c","30":"c3e082870fc081e3236a","31":"d2a5162ca832b69abd24","32":"312ee5a358b832135246","33":"6f8fc034ba3783a3128c","34":"4558130966686a3bf0a6","35":"44989108c1f6ae28bab1","36":"32dcffffbf701db087f3","37":"c30ff82ecff0dd48dcc1","38":"d19e6e2931873d2cacc6","39":"77a97ede386370881e96","40":"8d61d1833c7803a34fae","41":"f9bfe7b2b2515723e27c","42":"d959c85d3bfa5f14be00","43":"0a710e2bc7e8a3ddfbe7","44":"904ae0aa28d3248fb07f","45":"8094332608b215122202","46":"87c7a47831751d3d8b38","47":"638c784bba2538719524","48":"e8693968b40c6e96ff43","49":"a64e82df56578bcc9889","50":"af2835fed34aa4109329","51":"b38869c702127719f3f7","52":"8320302c7d0568994ee2","53":"025d45dc85f4f608d5ae","54":"0e0205cea738c72d1268","55":"e6e2c1fa1fa6700993ab","56":"4a88408d210465b53b87","57":"3b1c895479bb79615607","58":"06bd261f85eadc15b05e","59":"dcba37f2f85fb4227cd1","60":"9026dda5f2b6dfac34b8","61":"229c2dd747a7af46be7c","62":"3ae3f084853ec37e18c3","63":"b089434edb9e34cda4be","64":"5253294dd0156246cce8","65":"69f04f2ccb167d35a3d2","66":"8972f4f7a5f7ee06e055","133":"f786cd7bb5b5eed7ab45","134":"87287eb793cbaf5ca06f","135":"2bf016bbf9c3c8bddf55","136":"21d245f53546de77d457","137":"ed3257cf08c46657029a","138":"62f753a62fa13bfdd1ef","139":"0386ac82e0b9d122feee","140":"7eae48d56bc72ae68793","201":"3c7f52cd9debd06aea2e","203":"417d0abe0eff4e3874e4","204":"ca5a79673a2833e1a62c","205":"682ee00c25a22762d65f"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 207);
